var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38.9744,
    rx: 8.20513,
    fill: "#4B00A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9573 12.2569H23.6638C21.8667 12.2569 21.5305 13.0226 21.5305 14.1303V16.5879H25.8132L25.2448 20.4382H21.5345V30.3077H17.0637V20.4382H13.3333V16.5879H17.0597V13.7528C17.0597 10.4618 19.3251 8.66666 22.6272 8.66666C24.2042 8.66666 25.565 8.76995 25.9573 8.82337V12.2569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/Facebook Logo.f78ee21447499bfaf782497f2dc7e6dc.svg";
export { ForwardRef as ReactComponent };